/// <reference path="../types/index.d.ts" />

import '../client_forms/mculinary5/style.css';
import FormStructure from './mculinary5/form_structure';

export default FormStructure;